/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';
	/*globals SCS */

	// we register change event handlers for various input fields. Often we have
	// mutliple visibility containers depending on the same input field (we often
	// have one container visible while another is hidden). In this case we do not
	// want to be called multiple times for the change event handler. Therefore we
	// need a static value to keep track of which input fields we already listen for.
	var delegated = {};

	/**
	 * Hidden component which handles showing/hiding of contained form elements
	 * based on the state of a configured (name & value) form element.
	 *
	 * For example: If the check box with name=foo and value=bar is checked, this
	 * module is displayed, otherwise it is hidden.
	 *
	 * @author Stefan Koch and Cesar Keller, update: Renaldas Szentiks, Matthias Inauen
	 * @namespace Tc.Module
	 * @class VisibilityControlContainer
	 * @extends Tc.Module
	 */
	Tc.Module.VisibilityControlContainer = Tc.Module.extend({

		EVT_STEP_LOADED: 'steploaded',
		EVT_INIT: 'init',
		ANIMATION_DURATION: 250,

		FUNCTIONS: {
			dateDifferenceFromNow: 'moment(%1, "DD.MM.YYYY").diff(moment().startOf("day"),%2, true)',
			dateDifference: 'moment(%1, "DD.MM.YYYY").diff(moment(%2, "DD.MM.YYYY"),%3, true)',
			containsValue: '(%1+"").split(",").indexOf(%2) >= 0',
			containsWord: '(%1+"").indexOf(%2) >= 0'
		},

		animationType: '',
		authorMode: false,
		show: function () {
		},
		hide: function () {
		},

		contentMustStayAtPlaceInDom: true,
		content: $(),

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			// read config
			mod.name = $ctx.data('name');
			mod.dataAttr = $ctx.data('attr');
			mod.value = $ctx.attr('data-value');
			mod.action = $ctx.data('action');
			mod.expression = mod.prepareExpression($ctx.data('expression'));
			// the target field may reside in any form module on the page.
			mod.formModule = $('.modScForm');
			// fetch and cache form dom nodes
			mod.forms = $('>FORM', mod.formModule);
			mod.authorMode = $ctx.hasClass('author-mode');
			mod.animationType = $ctx.data('animationtype');

			mod.selectors = $ctx.data('selectors');

			mod.show = (mod.authorMode) ? mod.showAuthor : mod.showPublisher;
			mod.hide = (mod.authorMode) ? mod.hideAuthor : mod.hidePublisher;

			mod.contentMustStayAtPlaceInDom = !$ctx.closest('form').length;
			if (!mod.contentMustStayAtPlaceInDom) {
				mod.content = $('<div class="move-off-screen" />').appendTo($ctx.closest('.modScForm'));
			}

			mod.sandbox.subscribe('formpriceupdate', mod);

			callback();
		},

		isSimpleCheck: function () {
			return this.expression ? false : true;
		},

		showOrHide: function (caller) {
			var mod = this,
				isSuccess = false;

			if (this.isSimpleCheck()) {
				isSuccess = this.checkField();
			} else {
				isSuccess = this.checkExpression();
			}
			//see backend implementation
			isSuccess = isSuccess || (mod.selectors && mod.selectors.length > 0);
			if (isSuccess) {
				if (this.action === 'show') {
					this.show(caller);
				} else {
					this.hide(caller);
				}
			} else {
				if (this.action === 'show') {
					this.hide(caller);
				} else {
					this.show(caller);
				}
			}
		},

		prepareExpression: function (expression) {
			var $this = this,
				functionName;
			expression = expression.replace(new RegExp(' and ', 'g'), ' && ').replace(new RegExp(' or ', 'g'), ' || ');
			for (functionName in this.FUNCTIONS) {
				if (this.FUNCTIONS.hasOwnProperty(functionName)) {
					expression = this.prepareFunction({name: functionName, template: $this.FUNCTIONS[functionName]}, expression);
				}
			}
			return expression;
		},

		prepareFunction: function (functionDefinition, expression) {
			var functions = expression.match(new RegExp(functionDefinition.name + '[\\s]?\\([^\\)]+\\)', 'g')),
				i = 0,
				j = 0,
				data = [],
				template;

			for (; functions && i < functions.length; i += 1) {
				data = functions[i].substring(0, functions[i].length - 1).replace(new RegExp(functionDefinition.name + '[\\s]?\\('), '').split(',');
				if (data.length > 0) {
					template = functionDefinition.template;
					for (j = 0; j < data.length; j += 1) {
						template = template.replace(new RegExp('%' + (j + 1), 'g'), data[j]);
					}
					expression = expression.replace(functions[i], template);
				} else {
					expression = expression.replace(functions[i], '');
				}
			}
			return expression;
		},

		checkExpression: function () {
			var placeholders = this.getExpressionPlaceholders(),
				processedExpression = this.expression,
				i = 0,
				value = '';
			for (i = 0; placeholders && i < placeholders.length; i += 1) {
				value = this.getFieldValue(placeholders[i]);
				value = value.replace(new RegExp('\'', 'g'), '').replace(new RegExp('\\\\', 'g'), '');
				if (!value.match(/^[0-9]+$/)) {
					value = '\'' + value + '\'';
				}
				processedExpression = processedExpression.replace(new RegExp('\\$\\{' + placeholders[i] + '\\}', 'g'), value);
			}
			try {
				return eval(processedExpression); // TODO don't use eval. Refactor to use regular functions instead.
			} catch (e) {
				return false;
			}
		},

		getFieldValue: function (name) {
			var field = this.formModule.find('[name="' + name + '"],.active[data-name="' + name + '"]'),
				values = [],
				i = 0;
			//field is hidden in VCC
			if(field.closest('.move-off-screen').length > 0){
				return '';
			}
			if (field.attr('type') === 'radio') {
				field = this.formModule.find('[name="' + name + '"]:checked');
				return field.val() || '';
			} else if (field.attr('type') === 'checkbox') {
				field = this.formModule.find('[name="' + name + '"]:checked');
				for (i = 0; i < field.length; i += 1) {
					values.push($(field[i]).val());
				}
				return values.join(',');
			} else if (field.data('name')) {
				return field.data('value') || '';
			} else if (field.length > 0) {
				for (i = 0; i < field.length; i += 1) {
					values.push($(field[i]).val());
				}
				return values.join(',');
			}
			return field.val() || '';
		},

		getExpressionPlaceholders: function () {
			var mod = this,
				placeholders = [],
				i = 0,
				name;

			/* jshint maxdepth: 5 */
			if (!mod.expressionPlaceholders) {
				mod.expressionPlaceholders = [];
				if (mod.expression) {
					placeholders = mod.expression.match(/\$\{[a-zA-Z0-9_\\/:\\-]+\}/g);
					if (placeholders) {
						for (i = 0; i < placeholders.length; i += 1) {
							name = placeholders[i].replace('${', '').replace('}', '');
							if (mod.expressionPlaceholders.indexOf(name) < 0) {
								mod.expressionPlaceholders.push(name);
							}
						}
					}
				}
			}
			return mod.expressionPlaceholders;
		},

		checkField: function () {
			// input element name
			var mod = this,
				name = mod.name,
				value = mod.value;

			// forms have been prefetched on initialization
			for (var i = 0, L = mod.forms.length; i < L; i += 1) {
				// get element via form node
				var form = mod.forms[i],
					el = form.elements[name];
				// may not exist in this form
				if (!el) {
					continue;
				}
				// if Data Attribute is empty, check value
				if (!mod.dataAttr){
					// special test for checkbox
					if ($(el).attr('type') === 'checkbox') {
						// value is static and doesn't change with checked status
						if ($(el).is(':checked') &&
							$(el).filter(':checked')
								.map(function() { return this.value; })
								.get()
								.some(function (val) { return val === value; })) {
							return true;
						}
					} else if ($(el).attr('type') === 'radio') {
						if ($(el).filter(':checked').val() === mod.value) {
							return true;
						}
					}
					// generic form element handling
					else {
						// a HTMLFormElementsCollection returns a RadioNodeList if
						// multiple elements share the same name. The RadioNodeList
						// has special value semantics where it returns the value of
						// the first checked radio list in the nodelist. All other
						// standard types (textarea, text, hidden) have it anyway!
						if (el.value === mod.value) {
							return true;
						}
					}
				// check if Data Attribute has the desired value
				} else {
					// special test for checkbox
					if ($(el).attr('type') === 'checkbox') {
						// value is static and doesn't change with checked status
						if ($(el).is(':checked') && '' + $(el).filter(':checked').data(mod.dataAttr) === mod.value) {
							return true;
						}
					} else if ($(el).attr('type') === 'radio') {
						if ('' + $(el).filter(':checked').data(mod.dataAttr) === mod.value) {
							return true;
						}
					} else if ($(el).prop('tagName').toLowerCase() === 'select') {
						if ('' + $(el).find('option:selected').data(mod.dataAttr) === mod.value) {
							return true;
						}
					}
					// generic form element handling
					else {
						// a HTMLFormElementsCollection returns a RadioNodeList if
						// multiple elements share the same name. The RadioNodeList
						// has special value semantics where it returns the value of
						// the first checked radio list in the nodelist. All other
						// standard types (textarea, text, hidden) have it anyway!
						if (el.data(mod.dataAttr) === mod.value) {
							return true;
						}
					}
				}
			}

			return (mod.formModule.find('.active[data-name="' + mod.name + '"]').attr('data-value') === mod.value) ||
				// test below is for checkbox groups (each checkbox has same name; custom and strange logic)
				mod.formModule.find('INPUT[type="hidden"][name="' + mod.name + '_label"]:not([disabled])')
					.filter(function () {
						return this.value === value;
					}).length > 0;
		},

		showPublisher: function (caller) {
			var mod = this;

			if(mod.status === 'showing' || mod.status === 'shown') {
				return;
			}

			mod.$ctx.trigger('visibilityControl-show');
			mod.$ctx.removeClass('visibilityControl-hidden');

			if (!mod.inProgress) {
				mod.inProgress = true;
				mod.status = 'showing';

				if (mod.contentMustStayAtPlaceInDom) {
					mod.$ctx.removeClass('move-off-screen');
				} else {
					mod.$ctx.append(mod.content.children());
				}
				$('input, textarea', mod.$ctx).placeholder();

				if (this.formModule) {
					this.formModule.trigger('formFieldsChanged');
				}

				mod.showAnimation(function () {
					mod.inProgress = false;
					mod.status = 'shown';
					if (mod.queriedAction && mod.queriedAction === 'hide') {
						mod.queriedAction = null;
						mod.hide();
					} else {
						mod.queriedAction = null;
						// Only consider init events because stepload may be called between init and the time out
						if(caller === mod.EVT_INIT) {
							var oflow = mod.$ctx.css('overflow');
							if(!mod.$ctx.find('.modDropdownPopulation').length) {
								mod.$ctx.css('overflow', 'hidden');
							}

							window.setTimeout(function () {
								mod.$ctx.css('overflow', oflow);
							}, 0);
						}
					}
				});

				mod.$ctx.find('[data-clientvalidation]').removeData('do-not-validate');

			} else {
				if (caller !== mod.EVT_STEP_LOADED && caller !== mod.EVT_INIT) {
					mod.queriedAction = 'show';
				}
			}
			mod.$ctx.trigger('visibilityControl-afterShow', this);
			this.updateSubtotal();
			if(!mod.initializedChildren){
				mod.initializedChildren = true;
				SCS.utils.initNewModules(this.$ctx);
				if(mod.$ctx.find('.carouselContainer').length && !SCS.utils.isMobilePage()) {
					SCS.carousel.initializeCarousel.apply(mod.$ctx.find('.carouselContainer'));
					SCS.portal.synchronizeHeights($('.carouselContainer .sync-wrapper'));
				}
			}

			$(document).trigger('element-shown', [this.$ctx]);
		},

		updateSubtotal: function(){
			var $priceFields = this.$ctx.find(':input[data-price],:input[data-onetime-charge],:input[data-type=item]');
			if ($priceFields.length){
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},

		hidePublisher: function (caller) {
			var mod = this;

			if(mod.status === 'hiding' || mod.status === 'hidden') {
				return;
			}

			mod.$ctx.trigger('visibilityControl-hide');
			mod.$ctx.addClass('visibilityControl-hidden');

			if (!mod.inProgress) {
				mod.status = 'hiding';
				mod.inProgress = true;
				mod.hideAnimation(function () {
					mod.status = 'hidden';
					if (mod.animationType !== 'greyout') {
						if (mod.contentMustStayAtPlaceInDom) {
							mod.$ctx.addClass('move-off-screen').show();
						} else {
							mod.content.append(mod.$ctx.children());
						}
					}
					else {
						if(!mod.initializedChildren){
							mod.initializedChildren = true;
							SCS.utils.initNewModules(mod.$ctx);
						}
					}
					mod.inProgress = false;
					if (mod.queriedAction && mod.queriedAction === 'show') {
						mod.queriedAction = null;
						mod.show();
					} else {
						mod.queriedAction = null;
					}

					if(mod.contentMustStayAtPlaceInDom) {
						mod.$ctx.find('[data-clientvalidation]').data('do-not-validate', 'true');
					} else {
						mod.content.find('[data-clientvalidation]').data('do-not-validate', 'true');
					}

					// calling a method from Tc.Module.ProductOptionsSummaery.js to recalculate a price
					mod.fire('PriceAdded', {}, ['formpriceupdate']);

				});

			} else {
				if (caller !== mod.EVT_STEP_LOADED && caller !== mod.EVT_INIT) {
					mod.queriedAction = 'hide';
				}
			}
			mod.$ctx.trigger('visibilityControl-afterHide', this);
		},

		showAuthor: function () {
			this.$ctx.trigger('visibilityControl-show');
			this.$ctx.find('.section, .cq-editbar-placeholder').removeClass('move-off-screen');
			this.$ctx.trigger('visibilityControl-afterShow', this);
			this.updateSubtotal();
			//Commented at 11.03.2016, we need to investigate how to fix the lazy loading on Author
			//SCS.utils.initNewModules(this.$ctx);
		},

		hideAuthor: function () {
			this.$ctx.trigger('visibilityControl-hide');
			this.$ctx.find('.section, .cq-editbar-placeholder').addClass('move-off-screen');
			this.$ctx.trigger('visibilityControl-afterHide', this);
		},

		showAnimation: function (callback) {
			var mod = this;
			switch (mod.animationType) {
				case 'noanimation':
					mod.$ctx.css('display', 'block');
					callback();
					break;
				case 'greyout':
					mod.$ctx.fadeTo(mod.ANIMATION_DURATION, 1, callback);
					break;
				default:
					mod.$ctx.slideDown(mod.ANIMATION_DURATION, callback);
			}
		},

		hideAnimation: function (callback) {
			var mod = this;

			switch (mod.animationType) {
				case 'noanimation':
					mod.$ctx.css('display', 'none');
					callback();
					break;
				case 'greyout':
					mod.$ctx.fadeTo(mod.ANIMATION_DURATION, 0.4, callback);
					break;
				default:
					mod.$ctx.slideUp(mod.ANIMATION_DURATION, callback);
			}
		},

		getHiddenContentHandler: function (event, callback) {
			var mod = this;

			if (mod.$ctx.hasClass('move-off-screen') && mod.$ctx.children().length) {
				callback(mod.$ctx.children());
			} else if (mod.content.children().length) {
				callback(mod.content.children());
			}
		},

		attachEvents: function(fieldName) {
			var mod = this;
			delegated[fieldName] = [mod];

			// sync-ui event is triggered when a synced form field was updated
			// data-name comes from custom fields, that are not form fields but still trigger change events.
			// These type of fields occure in the Tc.Module.ProductModelFilter
			//
			// the visibility control container in simple mode has a attribute called data-name. The value will
			// correspond with the fieldName as this is the value it is supposed to observe for change.
			// make sure the visibility control containers do not trigger this event if a descendant child triggers
			// a change event.
			$(document).on('sync-ui change keyup', '[name="' + fieldName + '"]:not(.modVisibilityControlContainer), [data-name="' + fieldName + '"]:not(.modVisibilityControlContainer)', function (event) {

				for (var i = 0, L = delegated[fieldName].length; i < L; i += 1) {
					delegated[fieldName][i].showOrHide('change', event);
				}
				if (event.originalEvent && event.type !== 'sync-ui') {
					$(this).trigger('sync-heights');
				}
			});
			mod.forms.each(function(idx, frm) {
				var sdxInputGroups = frm.querySelectorAll('sdx-input-group');
				sdxInputGroups.forEach(function(item) {
					var originalClbck = item.changeCallback;
					item.getSelection().then(function() {
						$(item).find('input[name="' + fieldName + '"]').change();
					});
					item.changeCallback = function() {
						setTimeout(function () {
							$(item).find('input[name="' + fieldName + '"]').change();
							originalClbck && originalClbck();
						}, 10);
					};
				});
			});
		},

		getFieldNames: function() {
			if (this.isSimpleCheck()) {
				return [this.name];
			} else {
				return this.getExpressionPlaceholders();
			}
		},

		/**
		 * Initialize the component
		 */
		initModule: function(){
			var mod = this;
			var fieldNames = this.getFieldNames();

			this.showOrHide(this.EVT_INIT);

			for (var i = 0; i < fieldNames.length; i += 1) {
				if (delegated[fieldNames[i]]) {
					delegated[fieldNames[i]].push(mod);
				} else {
					mod.attachEvents(fieldNames[i]);
				}
			}
			// these two need to be optimized as well, they are being called multiple times, if there are more than one form element on the page.
			this.formModule.on(this.EVT_STEP_LOADED, $.proxy(this.showOrHide, this, this.EVT_STEP_LOADED)); // triggered by Tc.Module.ScForm.MultipageWizard
			this.$ctx.on('getHiddenContent', $.proxy(this.getHiddenContentHandler, this));
		},

		/**
		 * Hook which is triggered after all modules have executed "on".
		 *
		 * @method after
		 * @return void
		 */
		after: function () {
			if(this.$ctx.hasClass('disabled')) {
				return;
			}

			// only init the module after all other components have finished initializing.
			setTimeout(this.initModule.bind(this), 0);
		}
	});
})(window.Tc.$, window.Tc);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.VisibilityControlContainer.js
// module id = 292
// module chunks = 0